<div [class.has-error]="errorMessages && errorMessages.invalid">
  <ap-field
    #field
    [title]="label"
    [disabled]="disabled"
    [required]="isRequired"
    [error]="!!errorMessages && errorMessages.invalid">
    <input
      #input
      appkit-field
      [value]="value()"
      [attr.maxlength]="maxlength"
      (input)="onInput($event)"
      (blur)="blurHandler($event)"
      (focus)="focusHandler($event)" />
    @if (showSuggestion) {
      <div class="ap-field-suggestion">
        {{
          'suggestions.charactersRemaining'
            | translate: { count: valueLength() }
        }}
      </div>
    }
    @if (errorMessages && errorMessages.invalid) {
      <div class="ap-field-validation-error">
        {{ errorMessages.errorMessage }}
      </div>
    }
  </ap-field>
</div>
